module.exports = __webpack_public_path__ + "static/media/IMG_0536-2.5672d611.jpg";